import { Typography } from '@mui/material'

interface FileNameProps {
  name: string
  variant?: 'card' | 'chat'
  maxWidth?: number
}

export const FileName = ({ name, variant = 'card', maxWidth }: FileNameProps) => {
  const isChat = variant === 'chat'

  return (
    <Typography
      variant={isChat ? 'body2' : 'body2'}
      sx={{
        ml: isChat ? 1 : 0,
        mr: isChat ? 1 : 0,
        fontWeight: 500,
        whiteSpace: isChat ? 'nowrap' : 'normal',
        overflow: isChat ? 'hidden' : 'visible',
        textOverflow: isChat ? 'ellipsis' : 'unset',
        maxWidth: maxWidth || (isChat ? 120 : 'none'),
        wordBreak: isChat ? 'normal' : 'break-word',
      }}
      title={name}
    >
      {name}
    </Typography>
  )
}
